import React from "react";
import { useEffect, useState } from "react";
import { calculateTotalAmounts } from "./AdjustmentService";
import NumberInput from "../../shared/NumberInput";

export function AdjustmentFooter({adjustmentRows, buyScale, updateTotalValues}){

    const [totalBuyAmount, setTotalBuyAmount] = useState(0);

    useEffect(()=>{
        const calculateTotals = () =>{
        const totals = calculateTotalAmounts(adjustmentRows);
        
            if(totals)
            {
                setTotalBuyAmount(totals.BuyAmount);
                updateTotalValues(totals.BuyAmount);
            }
        }
        calculateTotals();
    },[adjustmentRows,updateTotalValues]);

return (
    <>
      <div  align="right" className="uk-grid">
        <div  className="uk-width-2-8"></div>
        <div  className="uk-width-2-8"></div>
        <div  className="uk-width-1-8"></div>
        <div  className="uk-width-1-8 uk-form-controls">
         <span >{'Subtotal'}</span>
         </div>
         <div className="uk-width-1-8 uk-form-controls">
            <NumberInput type="Currency" id={`txt-total-buy-amount`} key="txt-total-buy-amount" value={totalBuyAmount} disabled={true} scale={buyScale} />
         </div>
      </div>
    
    </>
  );
}

export default AdjustmentFooter